import type { ProductLike } from 'services/product.service';
import { formatPrice, CurrencyCode } from 'utils/HelperFn';

/**
 * Get the best available product image URL
 * Prefers large size, falls back to medium, then first available image
 */
export const getProductImage = (product: ProductLike | null | undefined): string => {
  if (!product || !product.images || product.images.length === 0) {
    return '';
  }

  return product.images[0] || '';
};

/**
 * Get formatted product price with currency symbol
 */
export const getProductPrice = (
  product: ProductLike,
  currencySymbol: string,
  currencyCode: CurrencyCode = 'GBP',
): string => {
  if (product.price && typeof product.price.rspExVat === 'number') {
    return formatPrice(product.price.rspExVat, currencySymbol, currencyCode);
  }
  return 'Price on request';
};

/**
 * Get formatted product VAT price with currency symbol
 */
export const getProductVatPrice = (
  product: ProductLike,
  currencySymbol: string,
  currencyCode: CurrencyCode = 'GBP',
): React.ReactNode => {
  if (product.price && typeof product.price.rspIncVat === 'number') {
    return formatPrice(product.price.rspIncVat, currencySymbol, currencyCode);
  }
  return '';
};

/**
 * Get product code (variant code or product code)
 */
export const getProductCode = (product: ProductLike): string => {
  return product.variantCode || ('productCode' in product ? product.productCode || 'N/A' : 'N/A');
};

/**
 * Get product description (variant description or product description)
 */
export const getProductDescription = (product: ProductLike): string => {
  return product.variantDescription || ('productDescription' in product ? product.productDescription || 'Product' : 'Product');
};
